import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

// libs/src/components/MissionWindow.tsx
dayjs.extend(utc);
const MissionWindow = ({
  liftoffTime,
  windowOpen,
  windowClose
}) => {
  const liftoff = liftoffTime ? Math.ceil(dayjs.utc(liftoffTime).valueOf() / (60 * 1000)) * 60 * 1000 : NaN;
  const current = !isNaN(liftoff) && liftoff <= Date.now() ? liftoff : Math.ceil(Date.now() / (60 * 1000)) * 60 * 1000;
  const start = Math.ceil(dayjs.utc(windowOpen).valueOf() / (60 * 1000)) * 60 * 1000;
  const end = Math.ceil(dayjs.utc(windowClose).valueOf() / (60 * 1000)) * 60 * 1000;
  const totalDuration = end - start;
  const liftoffFromStart = isNaN(liftoff) ? 0 : Math.max(0, liftoff - start);
  const nowFromStart = Math.max(0, current - start);
  const progressValue = Math.min(nowFromStart / totalDuration, 1) * 100;
  const bufferValue = isNaN(liftoff) ? 0 : Math.min(liftoffFromStart / totalDuration, 1) * 100;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      alignItems: 'center'
    }
  }, new Date(windowOpen).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit'
  }), /*#__PURE__*/React.createElement(LinearProgress, {
    variant: "buffer",
    value: progressValue,
    valueBuffer: bufferValue,
    "aria-label": "\u30DF\u30C3\u30B7\u30E7\u30F3\u30A6\u30A3\u30F3\u30C9\u30A6\u306E\u9032\u6357",
    sx: {
      '& .MuiLinearProgress-dashed': {
        backgroundColor: 'lightgrey',
        backgroundImage: 'none',
        animation: 'none'
      },
      flexGrow: 1,
      height: 10
    }
  }), new Date(windowClose).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit'
  })));
};

export { MissionWindow, MissionWindow as default };
